export default __webpack_public_path__ + "static/media/cardfinans_logo.c85db97c.png";